export default "__VITE_ASSET__CBfKVObS__"